import { createRoute } from "@tanstack/react-router";
import { RootRoute } from "../root-route";
import { SiteHeader } from "@/components/site-header";
import { SiteFooter } from "@/components/site-footer";
import { Code } from "lucide-react";

export const ApiRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: "/api",
  component: Api,
  head: () => ({
    meta: [
      { title: "API | Bevattningskartan" },
      { name: "description", content: "Vill du använda Bevattningskartans API? Hör av dig så berättar vi mer." },
    ],
    links: [
      { rel: "canonical", href: "https://bevattningskartan.se/api" },
    ],
  }),
});

function Api() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main className="mx-auto max-w-6xl px-4 py-10 sm:px-6 sm:py-14">
        <article className="max-w-2xl">
          <div className="flex items-center gap-3">
            <span className="grid h-10 w-10 place-items-center rounded-lg bg-primary text-primary-foreground">
              <Code className="h-5 w-5" strokeWidth={2.2} />
            </span>
            <h1 className="font-display text-4xl sm:text-5xl text-foreground">
              API
            </h1>
          </div>

          <p className="mt-4 text-muted-foreground">
            Vill du komma åt Bevattningskartans API? Hör av dig till oss så berättar
            vi mer om möjligheterna.
          </p>

          <p className="mt-6">
            <a
              href="mailto:hej@bevattningskartan.se"
              className="text-primary hover:underline"
            >
              hej@bevattningskartan.se 🙂
            </a>
          </p>
        </article>
      </main>
      <SiteFooter />
    </div>
  );
}
